import { call, put } from 'redux-saga/effects';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';
import { authorizedLoginSuccessful, refreshKeyCloakFailed, refreshKeyCloakSuccessful } from '../actions';

export default function* refreshKeyCloak(action) {
  try {
    yield window.keycloak.updateToken(10);
    const profile = yield window.keycloak.loadUserProfile();
    const { token } = window.keycloak;
    yield put(authorizedLoginSuccessful({ profile, token }));
    yield put(refreshKeyCloakSuccessful());
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(refreshKeyCloakFailed(e));
    yield processError(e);
  }
}
